var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{ref:"bodyNode",class:{ ee: _vm.storeName.EE, fr: _vm.storeName.FR }},[_c('StoreContainer'),_c('StoreFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }